import './index.css'

const EmploymentType = props => {
  const {eachType, onEmployType} = props

  const {label, employmentTypeId} = eachType
  const onEmployClick = () => {
    onEmployType(employmentTypeId)
  }

  return (
    <li>
      <input type="checkbox" id={employmentTypeId} onChange={onEmployClick} />
      <label htmlFor={employmentTypeId} className="employ-label">
        {label}
      </label>
    </li>
  )
}

export default EmploymentType
